







import Vue from 'vue'
import ModalManager from '@/components/all/modals/Index.vue'

export default Vue.extend({
    components: {
        ModalManager
    },
    created() {
        // check if the user has the token saved and load more stuff
        this.$store.dispatch('auth/checkForSavedToken')
    }
})
